import Vue from 'vue'
import ContextMenu from './main.vue'
let MenuConstructor = Vue.extend(ContextMenu)
const CtxMenu = function (menuData = [], targetData, e) {
    let instance = new MenuConstructor({
      data: {
        data: menuData,
      }
    })
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
    instance.vm.data = menuData
    console.log('open1')
    instance.vm.open(targetData, e)
}

CtxMenu.open = function (menuData, targetData, e) {
  // 调用open方法返回实例id
  return CtxMenu(menuData, targetData, e)
}



export default CtxMenu



// WEBPACK FOOTER //
// ./src/main.js